<div *ngIf="profileData.canAddMembers" class="d-flex justify-content-center flex-column align-items-center">
  <h3 *ngIf="titleText">
    {{titleText}}
  </h3>
  <button class="btn btn-theme text-white  ls-2 text-uppercase fw-boldest btn-md me-2" [routerLink]="'/team/list'" style="width: fit-content;">
    Add/Delete User
  </button>
</div>
